import {
  useSelfRegister,
  useSelfRegisterGetResendToken,
  useSelfRegisterPostResendToken,
} from 'hooks/useRegistration';

export function useRegisterForm() {

  const { mutate: register, isLoading: isRegistering, isSuccess: hasRegistered, isError: failedRegistering, } = useSelfRegister();
  const { mutate: getResendToken, isLoading: isGettingResendToken, isSuccess: hasGottenResendToken, isError: failedGettingResendToken, } = useSelfRegisterGetResendToken();
  const { mutate: postResendToken, isLoading: isPostingResendToken, isSuccess: hasPostedResendToken, isError: failedPostingResendToken, } = useSelfRegisterPostResendToken();

  return {
    register,
    isRegistering,
    hasRegistered,
    failedRegistering,
    getResendToken,
    isGettingResendToken,
    hasGottenResendToken,
    failedGettingResendToken,
    postResendToken,
    isPostingResendToken,
    hasPostedResendToken,
    failedPostingResendToken,
  }
  
}